import React from 'react'
import { useResponsiveBreakpoint } from 'hooks/useResponsiveBreakpoint'
import { useTheme } from '@mui/material/styles'
import Condition from 'components/Condition'
import ResponsiveButton from 'components/ResponsiveButton'
import StyledLink from 'components/StyledLink'
import { Create } from '@mui/icons-material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: `${theme.spacing(4)} !important`,
    [theme.breakpoints.down('sm')]: {
      marginBottom: `${theme.spacing(-2)} !important`,
    },
  },
  button: {
    width: 'auto !important',
    color: 'white !important',
    borderColor: 'white !important',
    marginLeft: `${theme.spacing(1)} !important`,
    [theme.breakpoints.down('sm')]: {
      marginTop: `${theme.spacing(-10)} !important`,
      height: '40px !important',
      width: '40px !important',
      border: 'none !important',
    },
  },
}))

function FreelancerProfileSelfActions() {
  const theme = useTheme()
  const isMobile = useResponsiveBreakpoint(theme.breakpoints.values.sm)
  const { classes } = useStyles()

  return (
    <div className={classes.buttons}>
      <Condition condition={isMobile}>
        <ResponsiveButton
          mobileLabel=""
          label=""
          icon={<Create />}
          component={StyledLink}
          href="/profile"
          className={classes.button}
        />
      </Condition>

      <Condition condition={!isMobile}>
        <ResponsiveButton
          mobileLabel="Edit"
          label="Edit Profile"
          icon={<Create />}
          component={StyledLink}
          href="/profile"
          className={classes.button}
        />
      </Condition>
    </div>
  )
}

export default React.memo(FreelancerProfileSelfActions)
